import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { Account } from 'app/_helper/user/user.types';
import { environment } from 'environments/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private _user = signal<Account>(null);
  private _httpClient = inject(HttpClient);

  /**
   * Constructor
   */
  constructor() {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Setter & getter for user
   *
   * @param value
   */
  set user$(value: Account) {
    // Store the value
    //this.get();
    this._user.set(value);
  }

  get user$(): Account {
    return this._user();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get the current logged in user data
   */
  async getUserData(): Promise<Account> {
    return await lastValueFrom(this._httpClient.get<Account>(`${environment.BASEURLAPI}/api/account`)).then((res) => {
      res.name = res.firstName + ' ' + res.lastName;
      this.user$ = res;

      return res;
    });
  }

  // /**
  //  * Update the user
  //  *
  //  * @param user
  //  */
  // update(user: User): Observable<any> {
  //   return this._httpClient.patch<User>('api/common/user', { user }).pipe(
  //     map((response) => {
  //       this._user.next(response);
  //     })
  //   );
  // }
}
